<div class="card card-webhook mb-3 cursor--pointer"  (click)="openWebHookDetails($event)">
    <div class="card-body card-body--webhook">
        <div class="d-flex h-100">
            <div class="d-flex flex-column justify-content-between w-100 ml-4" style="gap:2 rem">
                <div class="d-flex align-items-center mb-2">
                    <h5 class="subtitle-1--weight-regular mb-0">{{webHook?.name}}</h5>
                    <i class="fas fa-chevron-right ml-2" style="color: #000000;"></i>
                </div>
                <div class="mb-2">
                    <span [ngClass]="webHookStatusClass" class="body-2">
                        {{ webHookStatusLabel }}
                    </span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="body-1 ml-1">
                        Url: {{webHook.url}}
                    </div>

                    <ul class="d-flex flex-row justify-content-end actions-list list-group" style="height: 36px;" >
                        <li (click)="onEdit($event)"
                            class="list-group-item d-flex px-2 mr-2">
                            <i class="fas fa-edit pointer"></i>
                            <span class="ml-2 pointer expanded-text body-1 ">Edit</span>
                        </li>
                        <li (click)="onDelete($event)"
                            class="list-group-item d-flex px-2 mr-2">
                            <i class="fas fa-trash pointer"></i>
                            <span class="ml-2 pointer expanded-text body-1 ">Delete</span>
                        </li>
                        <li (click)="onTestSend($event)"
                            class="list-group-item d-flex px-2 mr-2">
                            <i class="fas fa-paper-plane"></i>
                            <span class="ml-2 pointer expanded-text body-1 ">Send test</span>
                        </li>
                    </ul> 
                </div>
            </div>
        </div>
    </div>
</div>